import type { CssGeneratorContext } from '../css-generator.model';

/** `data-risk-group` value on `app-risk-group-bubble` → risk colour group under `badge.extend`. */
const riskGroupTokens = [
	{ key: 'none', token: 'noneRisk' },
	{ key: 'very-small', token: 'verySmallRisk' },
	{ key: 'small', token: 'smallRisk' },
	{ key: 'medium', token: 'mediumRisk' },
	{ key: 'high', token: 'highRisk' },
] as const;

/**
 * Colours the badge inside `app-risk-group-bubble` by its `data-risk-group`: a full fill, or, with
 * `risk-group-bubble-initial`, a half-filled circle with a border in the group colour.
 */
export const styles = ({ dt }: CssGeneratorContext) => `.risk-group-bubble .p-badge {
  cursor: pointer;
  border: none;
}
${riskGroupTokens
	.map(
		({ key, token }) => `
.risk-group-bubble[data-risk-group='${key}'] .p-badge {
  background: ${dt(`badge.${token}.full.background`)};
}

.risk-group-bubble.risk-group-bubble-initial[data-risk-group='${key}'] .p-badge {
  background: linear-gradient(to left, ${dt(`badge.${token}.half.fill`)} 50%, ${dt(`badge.${token}.half.background`)} 50%);
  border: 2px solid ${dt(`badge.${token}.half.background`)};
}
`
	)
	.join('')}`;
